(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2d52"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2d52"] = parcelRequire;
}
parcelRequire.register("2n1zy", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $1b9ef3084b65f702$export$6503ec6e8aabbaf; }, function (v) { return $1b9ef3084b65f702$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $1b9ef3084b65f702$export$f7ad0328861e2f03; }, function (v) { return $1b9ef3084b65f702$export$f7ad0328861e2f03 = v; });
var $1b9ef3084b65f702$export$6503ec6e8aabbaf;
var $1b9ef3084b65f702$export$f7ad0328861e2f03;
"use strict";
var $1b9ef3084b65f702$var$mapping = {};
function $1b9ef3084b65f702$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$1b9ef3084b65f702$var$mapping[keys[i]] = pairs[keys[i]];
}
function $1b9ef3084b65f702$var$resolve(id) {
    var resolved = $1b9ef3084b65f702$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$1b9ef3084b65f702$export$6503ec6e8aabbaf = $1b9ef3084b65f702$var$register;
$1b9ef3084b65f702$export$f7ad0328861e2f03 = $1b9ef3084b65f702$var$resolve;

});

var $dd5a9c6ac1c8c21d$exports = {};

(parcelRequire("2n1zy")).register(JSON.parse('{"15lvv":"index.580b45d7.js","hur9p":"applicationinsights-react-js.3fb1b542.js","6tlE0":"applicationinsights-react-js.a59288e8.js","kGpDV":"applicationinsights-react-js.8599072a.js","95D1Z":"applicationinsights-web.19c32d6c.js","figP4":"applicationinsights-web.d944fe0f.js","2B4i3":"applicationinsights-clickanalytics-js.7a1a9336.js","7fb3i":"apple-touch-icon.176c0538.png","4wBTJ":"favicon.561cee98.png","4YVoE":"index.2664a438.css"}'));

})();
//# sourceMappingURL=index.f874f680.js.map
